import {
  Box,
  Typography,
  Paper,
  Chip,
  Avatar,
  Stack,
  CardContent,
  Card,
} from "@mui/material";
import { alpha } from "@mui/material/styles";
import { SmallLabel } from "../../../dashboards/Default/components/DashboardCard";

export function KpiCard({ icon, value, label, subLabel, delta, color }) {
  const colors = {
    blue: "#155dfc",
    green: "#00a63e",
    orange: "#f54900",
    rose: "#ec003f",
  };

  return (
    <Card>
      <CardContent sx={{ p: 5, "&:last-child": { pb: 5 } }}>
        <Stack
          direction="row"
          justifyContent="space-between"
          alignItems="flex-start"
          mb={2}
        >
          <Avatar
            sx={{
              bgcolor: alpha(colors[color], 0.12),
              color: colors[color],
              width: 40,
              height: 40,
            }}
          >
            {icon}
          </Avatar>
          {delta ? (
            <Chip
              label={delta}
              size="small"
              sx={{
                bgcolor: alpha("#16a34a", 0.12),
                color: "#16a34a",
                fontWeight: 700,
              }}
            />
          ) : null}
        </Stack>
        <Typography variant="h4" fontWeight={800}>
          {value}
        </Typography>
        <SmallLabel variant="body1" sx={{ mt: 0.5 }}>
          {label}
        </SmallLabel>
        {subLabel ? (
          <Typography variant="body2" color="text.secondary" sx={{ mt: 0.5 }}>
            {subLabel}
          </Typography>
        ) : null}
      </CardContent>
    </Card>
  );
}

export function PriorityBadge({ priority }) {
  const styles = {
    Low: { bg: "#f1f5f9", text: "#334155" },
    Medium: { bg: "#dbeafe", text: "#1d4ed8" },
    High: { bg: "#ffedd5", text: "#c2410c" },
    Critical: { bg: "#ffe4e6", text: "#be123c" },
  };
  const style = styles[priority] || styles.Low;

  return (
    <Chip
      label={priority}
      size="small"
      sx={{
        bgcolor: style.bg,
        color: style.text || "black",
        height: 20,
        fontWeight: "bold",
      }}
    />
  );
}

export function StatusBadge({ status }) {
  const styles = {
    // New API statuses
    Open: "#16669bff",
    "In Progress": "#f48b36",
    Analysis: "#f48b36",
    Suspended: "#f44336",
    Closed: "#4caf50",
  };

  return (
    <Chip
      label={status}
      size="small"
      sx={{
        color: "white",
        backgroundColor: styles[status] || "#94a3b8",
        height: 20,
        fontWeight: "bold",
      }}
    />
  );
}
